<template>
<v-app id="inspire">
    <div v-if="isAzureDeployed==1">
        <oauth-wrapper :authorizeUrl="authorizeUrl" :tokenUrl="tokenUrl" :logoutUrl="logoutUrl" :scope="scope" :client_id="client_id" :redirect_uri="redirect_uri" :resource="resource" :autoLogin="autoLogin" :loginIncrementor="loginIncrementor" :showDebugInfo="showDebugInfo" @logged-in="credentialschanged">

            <div v-if="loginComplete">
                <div v-if="user != null && user.userEmail != null && user.id != -1">
                    <v-navigation-drawer v-model="drawer" dark src="https://www.lyondellbasell.com/globalassets/news-events/media-kit/lyondellbasell-mediaimages-refinery-loc_pla_1145_0.jpg?id=8566" app>
                        <v-toolbar v-show="isLoggedInUserActive" color="primary">
                            <div style="text-align: right">
                                <v-avatar color="primary" small>
                                    <v-icon dark large v-show="profilePic == ''">account_circle</v-icon>
                                    <img :src="profilePic" alt="Base64 encoded image" v-show="profilePic != ''" />
                                </v-avatar>
                                <span>{{ user.userName }}</span>
                            </div>
                        </v-toolbar>
                        <v-card>
                            <v-list nav dense v-show="isLoggedInUserActive">
                                <v-list-item link v-for="(item, i) in items" :key="i" :to="item.link">
                                    <v-list-item-action>
                                        <v-icon>{{ item.icon }}</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ $t("home") }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-group prepend-icon="settings" value="true" v-show="hasAdminAccess && !hasGlobalAccess">
                                    <template v-slot:activator>
                                        <v-list-item-title>{{ $t("admin") }}</v-list-item-title>
                                    </template>
                                    <v-list-item v-for="(admin, i) in admin2" :key="i" link :to="admin.link">
                                        <v-list-item-title v-if="admin.text == 'Users'">{{
                $t("users")
              }}</v-list-item-title>
                                        <v-list-item-title v-if="admin.text == 'Plant Specific Data'">{{
                $t("plantspecificdata")
              }}</v-list-item-title>
                                        <v-list-item-title v-if="admin.text == 'Feedback'">{{
                $t("feedback")
              }}</v-list-item-title>
                                        <v-list-item-icon>
                                            <v-icon>{{ admin.icon }}</v-icon>
                                        </v-list-item-icon>
                                    </v-list-item>
                                </v-list-group>

                                <v-list-group prepend-icon="settings" value="true" v-show="hasGlobalAccess">
                                    <template v-slot:activator>
                                        <v-list-item-title>{{ $t("admin") }}</v-list-item-title>
                                    </template>
                                    <v-list-item v-for="(admin, i) in admins" :key="i" link :to="admin.link">
                                        <v-list-item-title v-if="admin.text == 'Users'">{{
                $t("users")
              }}</v-list-item-title>
                                        <v-list-item-title v-if="admin.text == 'Plants'">{{
                $t("plants")
              }}</v-list-item-title>
                                        <v-list-item-title v-if="admin.text == 'Plant Specific Data'">{{
                $t("plantspecificdata")
              }}</v-list-item-title>
                                        <v-list-item-title v-if="admin.text == 'Feedback'">{{
                $t("feedback")
              }}</v-list-item-title>
                                        <v-list-item-title v-if="admin.text == 'Languages'">{{
                $t("languages")
              }}</v-list-item-title>
                                        <v-list-item-icon>
                                            <v-icon>{{ admin.icon }}</v-icon>
                                        </v-list-item-icon>
                                    </v-list-item>
                                </v-list-group>
                            </v-list>
                        </v-card>
                    </v-navigation-drawer>

                    <v-app-bar app color="primary" dark>
                        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
                        <v-toolbar-title>{{ $t("title") }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-spacer>
                            <div style="text-align: right">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <!-- <v-btn color="primary" v-show="isLoggedInUserActive && isNonLYBUser"> -->
                                        <!-- <v-btn color="primary" v-show="isLoggedInUserActive"> -->
                                        <v-icon dark v-bind="attrs" v-on="on" @click.stop="fbdialog = true" v-show="isLoggedInUserActive && isNonLYBUser">feedback</v-icon>
                                        <!-- </v-btn> -->
                                        &nbsp;&nbsp;
                                        <v-dialog v-model="fbdialog" max-width="70%">
                                            <v-card>
                                                <v-card-title>
                                                    <span class="headline">{{ $t("feedback") }}</span>
                                                    <v-spacer></v-spacer>
                                                    <v-icon @click="
                        fbdialog = false;
                        $toast.clear();
                      ">close</v-icon>
                                                </v-card-title>
                                                <v-card-text>
                                                    <v-container>
                                                        <v-textarea outlined v-bind:label="$t('feedback')" v-model="feedbackItem.comments"></v-textarea>
                                                    </v-container>
                                                </v-card-text>
                                                <v-card-actions>
                                                    <v-btn color="blue darken-1" text @click="
                        fbdialog = false;
                        $toast.clear();
                      ">{{ $t("cancel") }}</v-btn>
                                                    <v-spacer></v-spacer>
                                                    <v-btn color="primary" dark class="mb-2" @click="fbsave">{{
                      $t("save")
                    }}</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </template>
                                    <span>Feedback</span>
                                </v-tooltip>
                                <v-btn v-show="isLoggedInUserActive" icon color="white" @click.stop="openUserPreference()">
                                    <v-icon>settings</v-icon>
                                </v-btn>
                                <v-dialog v-model="dialog" persistent max-width="600px">
                                    <v-card>
                                        <v-card-title>
                                            <span class="headline">{{ $t("userprofile") }}</span>
                                            <v-spacer></v-spacer>
                                            <v-icon @click="dialog = false">close</v-icon>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-container>
                                                <v-row>
                                                    <v-col cols="12" sm="8" md="8">
                                                        <v-select :items="languages" v-bind:label="$t('selectlanguage')" v-model="selectedlanguage" item-text="language" item-value="id" required></v-select>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="8" md="8">
                                                        <v-select :items="itemsddlDateFormat" v-bind:label="$t('selectdateformat')" v-model="selectedDateFormat" item-text="DateFormat" required="">
                                                        </v-select>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="8" md="8">
                                                        <v-select :items="itemsRowsPerPage" v-bind:label="$t('rowsperpage')" v-model="selectedRowsPerPage" required="">
                                                        </v-select>
                                                    </v-col>
                                                </v-row>
                                                <v-row v-show="
                      isLoggedInUserActive && isNonLYBUser && isUserInOnePlant
                    ">
                                                    <v-col cols="12" sm="8" md="8">
                                                        <v-select :items="allRelatedMGs" label="Select Maintenance Group" v-model="selectedMaintenanceGroup" item-text="value" item-value="id">
                                                        </v-select>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-btn color="blue darken-1" text @click="dialog = false">{{
                  $t("close")
                }}</v-btn>
                                            <v-spacer></v-spacer>
                                            <!-- <v-btn rounded small color="primary" dark @click="signout()">
                  Sign Out
                </v-btn> -->
                                            <v-spacer></v-spacer>
                                            <v-btn color="primary" @click="saveProfile">{{
                  $t("save")
                }}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </div>
                        </v-spacer>
                    </v-app-bar>
                    <v-main>
                        <v-container fluid>
                            <v-row align="start" justify="center">
                                <v-col class="text-center">
                                    <router-view />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-main>
                    <v-footer color="primary" app>
                        <span class="white--text">&copy; {{ new Date().getFullYear() }}</span>
                    </v-footer>
                </div>
                <div v-else>
                    <div class="center-screen">
                        <v-progress-circular :size="70" :width="7" color="purple" indeterminate></v-progress-circular>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="center-screen">
                    <v-progress-circular :size="70" :width="7" color="purple" indeterminate></v-progress-circular>
                </div>
            </div>
        </oauth-wrapper>
    </div>
    <div v-else>
        <div v-if="user != null && user.userEmail != null && user.id != -1">
            <v-navigation-drawer v-model="drawer" dark src="https://www.lyondellbasell.com/globalassets/news-events/media-kit/lyondellbasell-mediaimages-refinery-loc_pla_1145_0.jpg?id=8566" app>
                <v-toolbar v-show="isLoggedInUserActive" color="primary">
                    <div style="text-align: right">
                        <v-avatar color="primary" small>
                            <v-icon dark large v-show="profilePic == ''">account_circle</v-icon>
                            <img :src="profilePic" alt="Base64 encoded image" v-show="profilePic != ''" />
                        </v-avatar>
                        <span>{{ user.userName }}</span>
                    </div>
                </v-toolbar>
                <v-card>
                    <v-list nav dense v-show="isLoggedInUserActive">
                        <v-list-item link v-for="(item, i) in items" :key="i" :to="item.link">
                            <v-list-item-action>
                                <v-icon>{{ item.icon }}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t("home") }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-group prepend-icon="settings" value="true" v-show="hasAdminAccess && !hasGlobalAccess">
                            <template v-slot:activator>
                                <v-list-item-title>{{ $t("admin") }}</v-list-item-title>
                            </template>
                            <v-list-item v-for="(admin, i) in admin2" :key="i" link :to="admin.link">
                                <v-list-item-title v-if="admin.text == 'Users'">{{
                $t("users")
              }}</v-list-item-title>
                                <v-list-item-title v-if="admin.text == 'Plant Specific Data'">{{
                $t("plantspecificdata")
              }}</v-list-item-title>
                                <v-list-item-title v-if="admin.text == 'Feedback'">{{
                $t("feedback")
              }}</v-list-item-title>
                                <v-list-item-icon>
                                    <v-icon>{{ admin.icon }}</v-icon>
                                </v-list-item-icon>
                            </v-list-item>
                        </v-list-group>

                        <v-list-group prepend-icon="settings" value="true" v-show="hasGlobalAccess">
                            <template v-slot:activator>
                                <v-list-item-title>{{ $t("admin") }}</v-list-item-title>
                            </template>
                            <v-list-item v-for="(admin, i) in admins" :key="i" link :to="admin.link">
                                <v-list-item-title v-if="admin.text == 'Users'">{{
                $t("users")
              }}</v-list-item-title>
                                <v-list-item-title v-if="admin.text == 'Plants'">{{
                $t("plants")
              }}</v-list-item-title>
                                <v-list-item-title v-if="admin.text == 'Plant Specific Data'">{{
                $t("plantspecificdata")
              }}</v-list-item-title>
                                <v-list-item-title v-if="admin.text == 'Feedback'">{{
                $t("feedback")
              }}</v-list-item-title>
                                <v-list-item-title v-if="admin.text == 'Languages'">{{
                $t("languages")
              }}</v-list-item-title>
                                <v-list-item-icon>
                                    <v-icon>{{ admin.icon }}</v-icon>
                                </v-list-item-icon>
                            </v-list-item>
                        </v-list-group>
                    </v-list>
                </v-card>
            </v-navigation-drawer>

            <v-app-bar app color="primary" dark>
                <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
                <v-toolbar-title>{{ $t("title") }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer>
                    <div style="text-align: right">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <!-- <v-btn color="primary" v-show="isLoggedInUserActive && isNonLYBUser"> -->
                                <!-- <v-btn color="primary" v-show="isLoggedInUserActive"> -->
                                <v-icon dark v-bind="attrs" v-on="on" @click.stop="fbdialog = true" v-show="isLoggedInUserActive && isNonLYBUser">feedback</v-icon>
                                <!-- </v-btn> -->
                                &nbsp;&nbsp;
                                <v-dialog v-model="fbdialog" max-width="70%">
                                    <v-card>
                                        <v-card-title>
                                            <span class="headline">{{ $t("feedback") }}</span>
                                            <v-spacer></v-spacer>
                                            <v-icon @click="
                        fbdialog = false;
                        $toast.clear();
                      ">close</v-icon>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-container>
                                                <v-textarea outlined v-bind:label="$t('feedback')" v-model="feedbackItem.comments"></v-textarea>
                                            </v-container>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-btn color="blue darken-1" text @click="
                        fbdialog = false;
                        $toast.clear();
                      ">{{ $t("cancel") }}</v-btn>
                                            <v-spacer></v-spacer>
                                            <v-btn color="primary" dark class="mb-2" @click="fbsave">{{
                      $t("save")
                    }}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </template>
                            <span>Feedback</span>
                        </v-tooltip>
                        <v-btn v-show="isLoggedInUserActive" icon color="white" @click.stop="openUserPreference()">
                            <v-icon>settings</v-icon>
                        </v-btn>
                        <v-dialog v-model="dialog" persistent max-width="600px">
                            <v-card>
                                <v-card-title>
                                    <span class="headline">{{ $t("userprofile") }}</span>
                                    <v-spacer></v-spacer>
                                    <v-icon @click="dialog = false">close</v-icon>
                                </v-card-title>
                                <v-card-text>
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12" sm="8" md="8">
                                                <v-select :items="languages" v-bind:label="$t('selectlanguage')" v-model="selectedlanguage" item-text="language" item-value="id" required></v-select>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="8" md="8">
                                                <v-select :items="itemsddlDateFormat" v-bind:label="$t('selectdateformat')" v-model="selectedDateFormat" item-text="DateFormat" required="">
                                                </v-select>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="8" md="8">
                                                <v-select :items="itemsRowsPerPage" v-bind:label="$t('rowsperpage')" v-model="selectedRowsPerPage" required="">
                                                </v-select>
                                            </v-col>
                                        </v-row>
                                        <v-row v-show="
                      isLoggedInUserActive && isNonLYBUser && isUserInOnePlant
                    ">
                                            <v-col cols="12" sm="8" md="8">
                                                <v-select :items="allRelatedMGs" label="Select Maintenance Group" v-model="selectedMaintenanceGroup" item-text="value" item-value="id">
                                                </v-select>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn color="blue darken-1" text @click="dialog = false">{{
                  $t("close")
                }}</v-btn>
                                    <v-spacer></v-spacer>
                                    <!-- <v-btn rounded small color="primary" dark @click="signout()">
                  Sign Out
                </v-btn> -->
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" @click="saveProfile">{{
                  $t("save")
                }}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </div>
                </v-spacer>
            </v-app-bar>
            <v-main>
                <v-container fluid>
                    <v-row align="start" justify="center">
                        <v-col class="text-center">
                            <router-view />
                        </v-col>
                    </v-row>
                </v-container>
            </v-main>
            <v-footer color="primary" app>
                <span class="white--text">&copy; {{ new Date().getFullYear() }}</span>
            </v-footer>
        </div>
        <div v-else>
            <div class="center-screen">
                <v-progress-circular :size="70" :width="7" color="purple" indeterminate></v-progress-circular>
            </div>
        </div>
    </div>
</v-app>
</template>

<script>
/* eslint-disable */
import oauthWrapper from "@/components/auth/oauth-wrapper-pkce"
import axios from "axios";
import i18n from "./plugins/i18n";
import urlRewriter from "@/components/url-rewriter"
import credentialInfo from "@/mixins/credentials-mixin"
import requestsMixin from "@/mixins/requests"

//window.apiurl = 'http://localhost/HeadcountAPI/api';
//window.apiurl = '/HeadcountAPI/api';
//window.apiurl = "http://localhost:5489/api";
//window.apiurl = "https://as-contractorheadcount-dev.azurewebsites.net/api";
window.apiurl = process.env.API_URL + "/api";
window.azuredeployed = process.env.AZURE_DEPLOYED; //0=IIS; 1= Azure;
window.newwin = null;
export default {
    mixins: [credentialInfo, requestsMixin],
    components: {
        oauthWrapper,
        urlRewriter
    },
    props: {
        source: String,
    },
    data: () => ({
        isAzureDeployed: process.env.AZURE_DEPLOYED,
        itemsddlDateFormat: ["dd/mm/yyyy", "mm/dd/yyyy"],
        items: [{
            icon: "home",
            text: "Home",
            link: "/ContractorHeadCount/home",
        }, ],
        admins: [{
                icon: "people_outline",
                text: "Users",
                link: "/ContractorHeadCount/user",
            },
            {
                icon: "build",
                text: "Plant Specific Data",
                link: "/ContractorHeadCount/plantspecificdata",
            },
            {
                icon: "house",
                text: "Plants",
                link: "/ContractorHeadCount/plants",
            },
            {
                icon: "language",
                text: "Languages",
                link: "/ContractorHeadCount/languages",
            },
            {
                icon: "feedback",
                text: "Feedback",
                link: "/ContractorHeadCount/feedback",
            },
        ],
        admin2: [{
                icon: "people_outline",
                text: "Users",
                link: "/ContractorHeadCount/user",
            },
            {
                icon: "build",
                text: "Plant Specific Data",
                link: "/ContractorHeadCount/plantspecificdata",
            },
            {
                icon: "feedback",
                text: "Feedback",
                link: "/ContractorHeadCount/feedback",
            },
        ],
        renderLoginHtml: "",
        languages: [],
        drawer: null,
        user: null,
        useraccess: [],
        dialog: false,
        fbdialog: false,
        userlanguage: -1,
        selectedlanguage: -1,
        imageLogo: require("@/assets/LYB_Logo.png"),
        emailaddress: "",
        showmessage: false,
        showEmailForm: true,
        infomessage: "",
        usercode: "",
        selectedDateFormat: "mm/dd/yyyy",
        selectedRowsPerPage: 25,
        itemsRowsPerPage: ["25", "50", "100", "All"],
        feedbackItem: {
            reportedBy: "",
            comments: "",
        },
        allHCUsers: [],
        allCMData: [],
        allRelatedMGs: [],
        selectedMaintenanceGroup: -1,
        profilePic: "",
        loginComplete: false
    }),
    mounted() {
        if (process.env.AZURE_DEPLOYED == 0) {
            this.getUser();
        }
    },
    methods: {
        credentialschanged(credentials) {
            ;
            this.loginComplete = credentials;
            if (this.loginComplete) {
                this.getUser();
            }
        },
        getUser() {
            var self = this;
            i18n.locale = "1";

            if (
                self.$store.state.userDetails != null &&
                self.$store.state.userDetails.userEmail != null
            ) {
                self.user = self.$store.state.userDetails;
                self.getUserAccessFromAPI();

            } else {
                axios
                    .get(window.apiurl + "/usercontext", {
                        withCredentials: true,
                        headers: self.requestHeaders
                    })
                    .then((response) => {
                        self.user = response.data;
                        if (self.user != null && self.user.userEmail != null) {
                            //this.getLanguages();
                            self.$store.commit("globalUser", this.user);
                            self.getUserAccessFromAPI();
                        }
                    })
                    .catch((error) => console.log(error));
            }
            this.getUserHCFromAPI();
            this.getMasterDataFromAPI();

        },
        getUserAccessFromAPI() {
            var self = this;
            self.getProfilePic();
            const link1 =
                window.apiurl + "/MppiContractorLanguageMasters/GetSavedLanguages";
            axios
                .get(link1, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.languages = response.data;
                    const link =
                        window.apiurl + "/userheadcount/myview/" + self.user.userEmail;
                    axios
                        .get(link, {
                            withCredentials: true,
                            headers: self.requestHeaders
                        })
                        .then((response) => {
                            self.useraccess = response.data;
                            i18n.locale = self.useraccess[0].language;
                            self.userlanguage = Number(self.useraccess[0].language);
                            if (self.useraccess[0].preferredDateFormat != null) {
                                self.selectedDateFormat =
                                    self.useraccess[0].preferredDateFormat;
                            }
                            if (self.useraccess[0].rowsPerPage != null) {
                                self.selectedRowsPerPage =
                                    self.useraccess[0].rowsPerPage;
                            }
                            self.allRelatedMGs = [];
                            if (self.useraccess.length > 0) {
                                self.useraccess.forEach(function (elem, index) {
                                    Array.prototype.push.apply(
                                        self.allRelatedMGs,
                                        self.allCMData.filter(function (e) {
                                            return (
                                                e.plant == elem.plant &&
                                                e.categoryId == 2 &&
                                                elem.isActive == "Y"
                                            );
                                        })
                                    );
                                });
                            }
                            self.selectedMaintenanceGroup = Number(
                                self.useraccess[0].maintenanceGroup
                            );
                            if (!window.location.href.toString().includes("/ContractorHeadCount/")) {
                                self.$router.push("/ContractorHeadCount/home");
                            }
                        })
                        .catch((error) => console.log(error));
                    response.data.forEach((element) => {
                        const link2 =
                            window.apiurl +
                            "/MppiContractorLanguageMasters/GetTranslatedData/" +
                            element.id;
                        axios
                            .get(link2, {
                                withCredentials: true,
                                headers: self.requestHeaders
                            })
                            .then((response) => {
                                i18n.setLocaleMessage(element.id.toString(), response.data);
                            })
                            .catch((error) => console.log(error));
                    });
                })
                .catch((error) => console.log(error));
        },
        getLanguages() {
            var self = this;
            const link =
                window.apiurl + "/MppiContractorLanguageMasters/GetSavedLanguages";
            axios
                .get(link, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.languages = response.data;
                })
                .catch((error) => console.log(error));
        },
        getUserHCFromAPI() {
            var self = this;
            const link = window.apiurl + "/userheadcount";
            axios
                .get(link, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.allHCUsers = response.data;
                })
                .catch((error) => console.log(error));
        },
        getMasterDataFromAPI() {
            var self = this;
            const link = window.apiurl + "/MppiChCategoriesDatas";
            axios
                .get(link, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.allCMData = response.data;
                })
                .catch((error) => console.log(error));
        },
        saveProfile() {
            var self = this;
            const userProfile = {
                userEmail: self.user.userEmail,
                Language: self.selectedlanguage.toString(),
                PreferredDateFormat: self.selectedDateFormat != null ? self.selectedDateFormat.toString() : 'mm/dd/yyyy',
                RowsPerPage: self.selectedRowsPerPage != null ? self.selectedRowsPerPage : 25,
                MaintenanceGroup: self.selectedMaintenanceGroup.toString(),
            };
            const link = window.apiurl + "/userheadcount/updateprofile";
            axios
                .post(link, userProfile, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    if (response.data.isSucess) {
                        i18n.locale = self.selectedlanguage.toString();
                        this.$router.go();
                    }
                })
                .catch((error) => console.log(error));
            this.dialog = false;
        },
        fbsave() {
            var self = this;
            if (self.feedbackItem.comments == "") {
                self.$toast.clear();
                self.$toast.error("Feedback should not be blank.", { timeout: false });
            } else {
                self.feedbackItem.reportedBy = self.user.userName;
                const link = window.apiurl + "/MppiChFeedbacks/create";
                axios
                    .post(link, self.feedbackItem, {
                        withCredentials: true,
                        headers: self.requestHeaders
                    })
                    .then((response) => {
                        if (response.data.isSucess) {
                            self.$toast.clear();
                            self.$toast.success("Thank you for providing valuable feedback.");
                            var plantAdmins = [];
                            self.useraccess.forEach(function (elem, index) {
                                Array.prototype.push.apply(
                                    plantAdmins,
                                    self.allHCUsers.filter(
                                        (x) => x.plant == elem.plant && x.company == "LYB"
                                    )
                                );
                            });
                            if (plantAdmins.length < 0) {
                                plantAdmins = self.allHCUsers.filter(
                                    (x) => x.plant == "Global" && x.company == "LYB"
                                );
                            }
                            if (plantAdmins.length > 0) {
                                var allplantadmins = "";
                                plantAdmins.forEach(function (elem, index) {
                                    allplantadmins += elem.userEmail + ";";
                                });
                                var fbEmailBody = {
                                    feedback: self.feedbackItem.comments,
                                    sendTo: allplantadmins,
                                    sender: self.feedbackItem.reportedBy,
                                };
                                var link44 =
                                    "https://prod-05.southcentralus.logic.azure.com:443/workflows/d07eb17e39424749865c6a78f346264a/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=t6ytc2YyAbAyBn2pdhCrdXrd9b30MKMlQeAqQmY-xyM";
                                axios
                                    .post(link44, fbEmailBody, {
                                        withCredentials: true,
                                        headers: self.requestHeaders
                                    })
                                    .then(function (response) {})
                                    .catch(function (err) {
                                        console.log(err);
                                    });
                            }
                        }
                    })
                    .catch((error) => console.log(error));
                self.fbdialog = false;
            }
        },
        getEmailLoginUser() {
            const userCode = {
                userId: this.emailaddress,
                code: this.usercode,
            };
            i18n.locale = "1";
            axios
                .post(window.apiurl + "/usercontext/VerifyUserCode", userCode, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    if (response.data.isSucess) {
                        this.user = response.data.userInfo;
                        this.$store.commit("globalUser", this.user);
                        this.getUserAccessFromAPI();
                        //this.getLanguages();

                    } else {
                        this.infomessage =
                            "User cannot be verified. Please check if code is not expired or Email is correct.";
                        this.showmessage = true;
                        this.showEmailForm = true;
                    }
                })
                .catch((error) => console.log(error));
        },
        openUserPreference() {
            this.dialog = true
            this.selectedlanguage = this.userlanguage;
            this.getLanguages()
        },
        // signout() {
        //   sessionStorage.clear();
        //   this.$router.go();
        // },
        generateVerificationCode() {
            this.showmessage = false;
            if (this.emailaddress == "") {
                this.infomessage =
                    "Email address cannot be blank. Please use a valid email id.";
                this.showmessage = true;
            } else {
                axios
                    .get(
                        window.apiurl +
                        "/usercontext/GenerateVerifyCode/" +
                        this.emailaddress, {
                            withCredentials: true,
                            headers: self.requestHeaders
                        }
                    )
                    .then((response) => {
                        if (response.data) {
                            this.usercode = "";
                            this.showEmailForm = false;
                        } else {
                            this.infomessage =
                                "User Email is not setup for using this app. Please contact your system administrator.";
                            this.showmessage = true;
                        }
                    })
                    .catch((error) => console.log(error));
            }
        },
        getProfilePic() {
            var self = this
            self.profilePic = "";
            if (process.env.AZURE_DEPLOYED == 1) {
                const linkgetId =
                    window.apiurl +
                    "/MyDirectory/users/myphoto"
                axios
                    .get(linkgetId, {
                        withCredentials: true,
                        headers: this.requestHeaders
                    })
                    .then((response) => {
                        if (response.data != "")
                            self.profilePic = "data:image/jpg;base64,".concat(
                                self.profilePic.concat(response.data)
                            );
                        else self.profilePic = "";
                    })
                    .catch((error) => console.log(error));
            }

        },
    },
    computed: {
        hasGlobalAccess() {
            var globalaccess = false;
            var filterPlant = [];
            filterPlant = this.useraccess.filter(
                (x) => x.plant == "Global" && x.isActive == "Y"
            );
            if (filterPlant != null && filterPlant.length > 0) {
                globalaccess = true;
            }
            return globalaccess;
        },
        hasAdminAccess() {
            var adminaccess = false;
            var filterUser = [];
            filterUser = this.useraccess.filter(
                (x) => x.isActive == "Y" && (x.plant == "Global" || x.company == "LYB")
            );
            if (filterUser != null && filterUser.length > 0) {
                adminaccess = true;
            }
            return adminaccess;
        },
        isNonLYBUser() {
            var isnonlby = false;
            var filterUser = [];
            filterUser = this.useraccess.filter(
                (x) => x.isActive == "Y" && (x.plant == "Global" || x.company == "LYB")
            );
            if (filterUser != null && filterUser.length > 0) {
                isnonlby = false;
            } else {
                isnonlby = true;
            }
            return isnonlby;
        },
        isUserInOnePlant() {
            var inOnePlant = false;
            var filterUser = [];
            filterUser = this.useraccess.filter(
                (x) => x.isActive == "Y" && x.plant != "Global" && x.company != "LYB"
            );
            if (filterUser != null && filterUser.length == 1) {
                inOnePlant = true;
            }
            return inOnePlant;
        },
        isLoggedInUserActive() {
            var isuseractive = false;
            if (this.useraccess.length > 0) {
                this.useraccess.forEach(function (elem, index) {
                    if (elem.isActive == "Y") {
                        isuseractive = true;
                    }
                });
            }
            return isuseractive;
        },
    },
};
</script>

<style scoped>
.center-screen {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    min-height: 100vh;
    margin-top: 100px;
}

#axiosForm {
    /* Components Root Element ID */
    position: relative;
}

.loader {
    /* Loader Div Class */
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url("/assets/ajax-loader.gif");
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10000000;
    opacity: 0.4;
    filter: alpha(opacity=40);
}
</style>



// WEBPACK FOOTER //
// ./src/App.vue